import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNewbuildingCountLink } from './hooks';
import { trackListingJKClick } from './tracking';
import { closePromoDetails } from '../../actions/promoDetails';
import { NewbuildingsLink as NewbuildingsLinkV2 } from '../../components/NewbuildingsLinkV2';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { PromoDetailsModal as PromoDetailsModalV2 } from '../../components/PromoDetailsModalV2';
import { useOffersListingUrl } from '../../hooks';
import { selectIsPromoDetailsOpen, selectPromoDetails, selectPromoProduct } from '../../selectors/promoDetails';
import { IPromoProduct } from '../../types/product';
import { useApplicationContext } from '../../utils/applicationContext';
import { NewbuildingLinkContainer } from '../NewbuildingsLinkContainer';

export const PromoDetailsModalContainer = () => {
  const isOpen = useSelector(selectIsPromoDetailsOpen);
  const promoDetails = useSelector(selectPromoDetails);
  const promoProduct = useSelector(selectPromoProduct);
  const dispatch = useDispatch();

  const { config } = useApplicationContext();
  const isRedesign = config.get<boolean>('newbuildingPromos.seo.Enabled') ?? false;

  const newbuildingCountLink = useNewbuildingCountLink(promoDetails);
  const offersListingUrl = useOffersListingUrl(promoDetails?.newbuildingIds || []);

  const closePromoDetailsModal = React.useCallback(() => {
    dispatch(closePromoDetails());
  }, [dispatch]);

  const handleLinkClick = React.useCallback(() => {
    trackListingJKClick({ product: promoProduct as IPromoProduct });
  }, [promoProduct]);

  if (!isOpen || !promoDetails) {
    return null;
  }

  if (isRedesign) {
    return (
      <PromoDetailsModalV2
        onClose={closePromoDetailsModal}
        promoName={promoDetails.promoName}
        providerName={promoDetails.providerName}
        logo={promoDetails.providerLogo}
        features={promoDetails.promoProps}
        description={promoDetails.promoDescription}
        banks={promoDetails.banks}
        newbuildingCountText={promoDetails.newbuildingCountText}
        newbuildingCountLink={newbuildingCountLink}
        newbuildingLinks={promoDetails.newbuildingLinks}
        newbuildingButton={<NewbuildingsLinkV2 url={offersListingUrl} />}
      />
    );
  }

  return (
    <PromoDetailsModal
      onClose={closePromoDetailsModal}
      banks={promoDetails.banks}
      builders={promoDetails.builders}
      name={promoDetails.promoName}
      logo={promoDetails.providerLogo}
      description={promoDetails.promoDescription}
      features={promoDetails.promoProps}
      newbuildingButton={
        <NewbuildingLinkContainer
          desktopUrl={promoDetails.newbuildingListingUrlDesktop}
          mobileUrl={promoDetails.newbuildingListingUrlMobile}
          onClick={handleLinkClick}
        />
      }
    />
  );
};
